import { GetterTree } from 'vuex';
import { DiscoveryWallState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { DiscoveryWallRecommendationsGetter } from './getters/discovery-wall-recommendations.getter';
import { DiscoveryWallRequestsGetter } from './getters/discovery-wall-requests.getter';
import { DiscoveryWallTrackingGetter } from './getters/discovery-wall-tracking.getter';

export const DISCOVERY_WALL_GETTERS: GetterTree<DiscoveryWallState, RootStoreState> = {
  ...new DiscoveryWallRecommendationsGetter().getters,
  ...new DiscoveryWallRequestsGetter().getters,
  ...new DiscoveryWallTrackingGetter().getters
};
